import { SchedulePipeline, DeletePipelineDialog } from "../components"


const OverlayProvider = () => {
    return (
        <>
            <SchedulePipeline />
            <DeletePipelineDialog />
        </>
    )
}

export default OverlayProvider;